import * as React from 'react';

// tslint:disable:max-line-length
export const PetsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M11.793 2.347A4.953 4.953 0 0 0 10 2H6c-.634 0-1.235.13-1.793.347C3.324.943 1.78 0 0 0v4c0 .919.421 1.73 1.073 2.276C1.038 6.514 1 6.752 1 7v4c0 2.757 2.243 5 5 5h4c2.757 0 5-2.243 5-5V7c0-.248-.038-.486-.073-.724A2.96 2.96 0 0 0 16 4V0c-1.78 0-3.324.943-4.207 2.347zM13 11c0 1.654-1.346 3-3 3H9v-2l1.146-1.146A.5.5 0 0 0 9.793 10H6.207a.5.5 0 0 0-.353.854L7 12v2H6c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h4c1.654 0 3 1.346 3 3v4z" />
      <circle cx="6" cy="8" r="1" />
      <circle cx="10" cy="8" r="1" />
    </g>
  </svg>
);
